/**
 * Dossier entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Dossier extends BaseModel {
    defaults() {
        return {
            id: null,
            name: null,
            description: null,
            slug: null,
            show_in_frontend: null,
            order_number: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            show_in_frontend: Boolean,
        };
    }

    entityName() {
        return 'Dossier';
    }
}

export class DossierCollection extends BaseCollection {
    options() {
        return {
            model: Dossier,
        };
    }

    entityName() {
        return 'Dossier';
    }
}
